import dayjs from "dayjs";

// export const deltaMonth = (dateStr, months) => {
//   return dayjs(dateStr).add(months, "month").format("YYYY-MM-DD");
// };

// export const startEndDates = (stDay, billingMonths = 1) => {
//   const today = dayjs().format("YYYY-MM-DD");
//   const todayObj = dayjs();
//   const todayDay = todayObj.date();

//   let cEndDate = dayjs().date(stDay).format("YYYY-MM-DD");

//   const decrement = stDay > todayDay ? -1 : 0;

//   cEndDate = deltaMonth(cEndDate, decrement);

//   const cStartDate = deltaMonth(cEndDate, -billingMonths);

//   cEndDate = dayjs(cEndDate).subtract(1, "day").format("YYYY-MM-DD");

//   return {
//     today,
//     cStartDate,
//     cEndDate,
//   };
// };

export const deltaMonth = (dateStr, months) => {
  return dayjs(dateStr).add(months, "month").format("YYYY-MM-DD");
};

export const startEndDates = (stDay, billingMonths = 1) => {
  const today = dayjs().format("YYYY-MM-DD");

  const todayObj = dayjs(today);

  const decrement = stDay > todayObj.date() ? -1 : 0;

  const baseCutoff = dayjs(
    `${todayObj.year()}-${String(todayObj.month() + 1).padStart(2, "0")}-${String(stDay).padStart(2, "0")}`,
  )
    .add(decrement, "month")
    .format("YYYY-MM-DD");

  const candidates = [];

  for (let i = 0; i < billingMonths; i++) {
    const cutoffDate = deltaMonth(baseCutoff, -i);

    const cStartDate = deltaMonth(cutoffDate, -billingMonths);

    const cEndDate = dayjs(cutoffDate).subtract(1, "day").format("YYYY-MM-DD");

    candidates.push({
      cStartDate,
      cEndDate,
    });
  }

  return {
    today,
    candidates,
  };
};

export const getPreviousMonthFirstDate = () => {
  const today = new Date();
  // Step 1: Always go to the 1st of current month
  today.setDate(1);
  // Step 2: Then move one month back
  today.setMonth(today.getMonth() - 1);

  // Step 3: Format as YYYY-MM-DD
  return formatDateToYYYYMMDD(today);
};

const formatDateToYYYYMMDD = (dateInput) => {
  const date = new Date(dateInput);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDate = (dateString) => {
  if (dateString) {
    const dateObject = new Date(dateString);
    const day = dateObject.getDate().toString().padStart(2, "0");
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  }
  return "-";
};

export const formatBytes = (bytes) => {
  if (bytes === 0) return " ";
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};
